import React from "react";
import styled, { css, keyframes } from "styled-components";
import { ColorTokens, useColorTokens } from "@tvg/design-system";

const pulseAnimation = (colorTokens: ColorTokens) => keyframes`
    0% {
      fill: ${colorTokens.content.loadingDefault};
    }

    50% {
      fill: ${colorTokens.border.default};
    }

    100% {
      fill: ${colorTokens.content.loadingDefault};
    }
`;

const SVG = styled.svg`
  display: block;
  width: 100%;
  height: 324px;

  rect.pulse {
    animation: ${() => {
      const colorTokens = useColorTokens();
      return css`
        ${pulseAnimation(colorTokens)} 1.25s infinite
      `;
    }};
  }
`;

export const PastPerformanceMask = () => {
  const colorTokens = useColorTokens();
  return (
    <div data-qa-label="ippMask">
      <SVG>
        <rect
          width="100%"
          height="324"
          fill={colorTokens.content.loadingDefault}
          rx=".5"
        />
        <rect
          className="pulse"
          width="298"
          height="12"
          x="12"
          y="84"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="248"
          height="12"
          x="12"
          y="60"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="184"
          height="12"
          x="12"
          y="36"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="81"
          height="12"
          x="69"
          y="12"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="49"
          height="12"
          x="12"
          y="12"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="298"
          height="12"
          x="12"
          y="192"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="248"
          height="12"
          x="12"
          y="168"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="184"
          height="12"
          x="12"
          y="144"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="81"
          height="12"
          x="69"
          y="120"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="49"
          height="12"
          x="12"
          y="120"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="298"
          height="12"
          x="12"
          y="300"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="248"
          height="12"
          x="12"
          y="276"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="184"
          height="12"
          x="12"
          y="252"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="81"
          height="12"
          x="69"
          y="228"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="49"
          height="12"
          x="12"
          y="228"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          width="100%"
          height="1"
          y="107"
          fill={colorTokens.content.loadingDefault}
          rx=".5"
        />
        <rect
          width="100%"
          height="1"
          fill={colorTokens.content.loadingDefault}
          rx=".5"
        />
        <rect
          width="100%"
          height="1"
          y="215"
          fill={colorTokens.content.loadingDefault}
          rx=".5"
        />
        <rect
          width="100%"
          height="1"
          y="323"
          fill={colorTokens.content.loadingDefault}
          rx=".5"
        />
      </SVG>
    </div>
  );
};
